import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TeComponent } from './common/te-component';
import './te-spacing';
import './te-icon';
import './te-text';
import { theme } from './common/theme';
import { IconName } from './te-icon';

/** Search Spotlight Item Component */
@customElement('te-spotlight-item')
export class TeSpotlightItem extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .spotlight-item {
        display: flex;
        align-items: center;
        height: 40px;
        padding-right: 16px;
        border-bottom: 1px solid ${theme.colors.shade2};
        cursor: pointer;
      }

      .spotlight-item:hover {
        background-color: ${theme.colors.shade1};
      }

      .icon-wrapper {
        height: 40px;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ];

  /** Icon name from icon pack */
  @property({ type: String }) icon?: IconName;
  /** Text value for spotlight item */
  @property({ type: String }) text = '';

  renderIcon() {
    if (this.icon) {
      return html`
        <te-icon name=${this.icon} wrapperSize="40" size="14"></te-icon>
      `;
    }
    return html`
      <te-spacing></te-spacing>
    `;
  }

  render() {
    return html`
      <div class="spotlight-item" @click=${this.handleClick}>
        ${this.renderIcon()}
        <te-text size="14">${this.text}</te-text>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-spotlight-item': TeSpotlightItem;
  }
}
